import { createApp } from 'vue';
import GarminGpxConverter from './GarminGpxConverter.vue';
import { i18n } from '../../i18n';

const el = document.getElementById('vue-garmin-gpx');
if (el) {
  createApp(GarminGpxConverter).use(i18n).mount(el);
}
